import { TicketIdentity } from "@accurx/api/ticket";
import { Conversation } from "domains/concierge/types";

export const mapTicketIdentityToConversationId = (
    identity: TicketIdentity,
): Conversation["id"] => {
    return `t-${identity.type}-${identity.id}`;
};
